import React, { useState } from "react";
import Internship_Program_Card from "../../../../common_components/common-cards/internship-program-card/Internship_Program_Card";
import Internship_Program_Details from "../../../../common_components/common-cards/internship-program-details/Internship_Program_Details";
import { Col, Row } from "react-bootstrap";

const Collage_offer = ({
  isMyApplications = false,
  onShowDetails,
  onBackToList,
}) => {
  const [selectedProgram, setSelectedProgram] = useState(null);

  const internships = [
    {
      companyLogo:
        "/assets/images/common-card/internship-program/internship-logo.png",
      companyTitle: "Ritz Paris",
      countryFlag: "/assets/images/common-card/study-program/flag-2.png",
      title: "Sous Chef",
      description:
        "Train as a professional Sous Chef with hands-on experience in international kitchens & mentorship from expert chefs abroad.",
      image: "/assets/images/common-card/internship-program/internship-img.png",
      details: {
        start: "20-05-2025",
        end: "20-10-2025",
        hours: "48 Hrs/week",
      },
      benefits: {
        meals: "Yes",
        uniform: "Yes",
        laundry: "No",
        accommodation: "Single Room",
      },
      requirements: {
        french: "C1",
        english: "B1",
      },
      documents: ["FR Language CV", "Portfolio"],
      stipend: "€1,000/month",
      status: "under_review",
    },

    {
      companyLogo:
        "/assets/images/common-card/internship-program/internship-logo.png",
      companyTitle: "Ritz Paris",
      countryFlag: "/assets/images/common-card/study-program/flag-2.png",
      title: "Sous Chef",
      description:
        "Train as a professional Sous Chef with hands-on experience in international kitchens & mentorship from expert chefs abroad.",
      image: "/assets/images/common-card/internship-program/internship-img.png",
      details: {
        start: "20-05-2025",
        end: "20-10-2025",
        hours: "48 Hrs/week",
      },
      benefits: {
        meals: "Yes",
        uniform: "Yes",
        laundry: "No",
        accommodation: "Single Room",
      },
      requirements: {
        french: "C1",
        english: "B1",
      },
      documents: ["FR Language CV", "Portfolio"],
      stipend: "€1,000/month",
      status: "under_review",
    },

    {
      companyLogo:
        "/assets/images/common-card/internship-program/internship-logo.png",
      companyTitle: "Ritz Paris",
      countryFlag: "/assets/images/common-card/study-program/flag-2.png",
      title: "Sous Chef",
      description:
        "Train as a professional Sous Chef with hands-on experience in international kitchens & mentorship from expert chefs abroad.",
      image: "/assets/images/common-card/internship-program/internship-img.png",
      details: {
        start: "20-05-2025",
        end: "20-10-2025",
        hours: "48 Hrs/week",
      },
      benefits: {
        meals: "Yes",
        uniform: "Yes",
        laundry: "No",
        accommodation: "Single Room",
      },
      requirements: {
        french: "C1",
        english: "B1",
      },
      documents: ["FR Language CV", "Portfolio"],
      stipend: "€1,000/month",
      status: "under_review",
    },
    {
      companyLogo:
        "/assets/images/common-card/internship-program/internship-logo.png",
      companyTitle: "Ritz Paris",
      countryFlag: "/assets/images/common-card/study-program/flag-2.png",
      title: "Sous Chef",
      description:
        "Train as a professional Sous Chef with hands-on experience in international kitchens & mentorship from expert chefs abroad.",
      image: "/assets/images/common-card/internship-program/internship-img.png",
      details: {
        start: "20-05-2025",
        end: "20-10-2025",
        hours: "48 Hrs/week",
      },
      benefits: {
        meals: "Yes",
        uniform: "Yes",
        laundry: "No",
        accommodation: "Single Room",
      },
      requirements: {
        french: "C1",
        english: "B1",
      },
      documents: ["FR Language CV", "Portfolio"],
      stipend: "€1,000/month",
      status: "under_review",
    },
    {
      companyLogo:
        "/assets/images/common-card/internship-program/internship-logo.png",
      companyTitle: "Ritz Paris",
      countryFlag: "/assets/images/common-card/study-program/flag-2.png",
      title: "Sous Chef",
      description:
        "Train as a professional Sous Chef with hands-on experience in international kitchens & mentorship from expert chefs abroad.",
      image: "/assets/images/common-card/internship-program/internship-img.png",
      details: {
        start: "20-05-2025",
        end: "20-10-2025",
        hours: "48 Hrs/week",
      },
      benefits: {
        meals: "Yes",
        uniform: "Yes",
        laundry: "No",
        accommodation: "Single Room",
      },
      requirements: {
        french: "C1",
        english: "B1",
      },
      documents: ["FR Language CV", "Portfolio"],
      stipend: "€1,000/month",
      status: "under_review",
    },
    {
      companyLogo:
        "/assets/images/common-card/internship-program/internship-logo.png",
      companyTitle: "Ritz Paris",
      countryFlag: "/assets/images/common-card/study-program/flag-2.png",
      title: "Sous Chef",
      description:
        "Train as a professional Sous Chef with hands-on experience in international kitchens & mentorship from expert chefs abroad.",
      image: "/assets/images/common-card/internship-program/internship-img.png",
      details: {
        start: "20-05-2025",
        end: "20-10-2025",
        hours: "48 Hrs/week",
      },
      benefits: {
        meals: "Yes",
        uniform: "Yes",
        laundry: "No",
        accommodation: "Single Room",
      },
      requirements: {
        french: "C1",
        english: "B1",
      },
      documents: ["FR Language CV", "Portfolio"],
      stipend: "€1,000/month",
      status: "under_review",
    },
  ];

  /* ================= HANDLERS ================= */

  const handleViewDetails = (program) => {
    setSelectedProgram(program);
    onShowDetails?.();
  };

  const handleBack = () => {
    setSelectedProgram(null);
    onBackToList?.();
  };

  /* ================= DETAIL VIEW ================= */

  if (selectedProgram) {
    const mappedDetailData = {
      logo: selectedProgram.companyLogo,
      companyName: selectedProgram.companyTitle,
      location: "15 Pl. Vendôme, 75001 Paris, France",
      flag: selectedProgram.countryFlag,
      bannerImage: "/assets/images/common-card/detail-card/detail-img-1.png ",
      title: "Sous Chef Food & Bevrages",
      description: selectedProgram.description,
      startDate: selectedProgram.details.start,
      endDate: selectedProgram.details.end,
      workHours: selectedProgram.details.hours,
      vacancies: "08",
      benefits: [
        {
          label: "Accommodation",
          value: selectedProgram.benefits.accommodation,
        },
        { label: "Meals Provided", value: selectedProgram.benefits.meals },
        { label: "Uniform Provided", value: selectedProgram.benefits.uniform },
        { label: "Laundry Service", value: selectedProgram.benefits.laundry },
      ],
      requirements: [
        `French level required: ${selectedProgram.requirements.french}`,
        `English level required: ${selectedProgram.requirements.english}`,
      ],
      documents: selectedProgram.documents,
      contact: {
        name: "Adrien Bernard",
        email: "a.bernard@ritzparis.com",
      },
      stipend: selectedProgram.stipend,
    };

    return (
      <Internship_Program_Details data={mappedDetailData} onBack={handleBack} />
    );
  }

  /* ================= LIST VIEW ================= */

  return (
    <div className="">
      <Row className="g-4">
        {internships.map((item, index) => (
          <Col key={index} lg={4} md={6} sm={12}>
            <Internship_Program_Card
              {...item}
              showBadge={isMyApplications}
              status={item.status}
              onViewDetails={() => handleViewDetails(item)}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Collage_offer;
